module.exports = __webpack_public_path__ + "img/ore-silver.a81376a0.svg";